import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { useClientConfig } from '@workspace/public-utils'

type OgType = 'website' | 'article'

export type SeoProps = {
  title: string
  description?: string
  canonicalPath?: string
  noindex?: boolean
  ogType?: OgType
}
const DEFAULT_DESCRIPTION =
  '프리미엄 로또 번호 생성 및 분석 서비스 - 정확한 통계와 분석으로 당신의 행운을 찾아보세요.'

function buildCanonicalUrl(pathname: string): string {
  try {
    return new URL(pathname, window.location.origin).toString()
  } catch {
    return pathname
  }
}

export function Seo({
  title,
  description,
  canonicalPath,
  noindex = false,
  ogType = 'website',
}: SeoProps) {
  const location = useLocation()
  const { defaultSiteName } = useClientConfig()
  const canonical = buildCanonicalUrl(canonicalPath ?? location.pathname)

  const fullTitle = title.includes(defaultSiteName) ? title : `${title} | ${defaultSiteName}`
  const desc = description ?? DEFAULT_DESCRIPTION
  const robots = noindex ? 'noindex,nofollow' : 'index,follow'

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  )
}


